//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 import { mapState } from 'vuex'
 export default {
     computed: {
         ...mapState({
             showSingle: ({ resourcesStore: {showSingle} }) => showSingle,
         }),
     },
     methods: {
         close: function() {
             if (event.srcElement.className == 'modal-container' || event.srcElement.className == 'close_container') {
                this.$store.commit('modalStore/setModal', false)
            }
        },
    }
}
